export default {
  10: 'active',
  1: 'blocked',
  0: 'inactive',
};
